<script>
    import MarketingCoursesDropdown from './MarketingCoursesDropdown'

    import {Form} from '../../../../helpers/Form/Form'

    export default {
        name: 'MarketingServices',
        components: {MarketingCoursesDropdown},
        props: ['userprop', 'companyprop', 'source', 'intentPayment', 'inPayment'],
        data() {
            return {
                stripe: {},
                form: new Form({
                    stripeToken: null,
                    pay_method: null,
                    p_intent: null,
                    email: this.userprop.email,
                    company_id: this.companyprop.id,
                    total: 0,
                    cart: []
                }),
                selectedCourses: [],
                stripeCheckout: null,
                days_options: [
                    '15',
                    '30',
                    '45',
                    '60',
                    '120',
                    '180',
                    '360'
                ],
                day_amounts: [
                    '1',
                    '2',
                    '3',
                    '5',
                    '10',
                    '15',
                    '20',
                    '30'
                ],
                product: {},
                google_courses: [],
                day_google_selected: 15,
                amount_google_selected: 1,
                social_courses: [],
                day_social_selected: 15,
                amount_social_selected: 1,
                total: 0,
                google_inserted: false,
                social_inserted: false,
                isOpened: false,
                submitRunning: false
            }
        },
        computed: {
            currentGoogleItems() {
                let googleItems = []
                let items = this.form.cart.filter(i => i.type == 'Google')
                items.forEach(i => {
                    googleItems = googleItems.concat(i.courses)
                })
                return googleItems
            },
            currentSocialItems() {
                let socialItems = []
                let items = this.form.cart.filter(i => i.type != 'Google')
                items.forEach(i => {
                    socialItems = socialItems.concat(i.courses)
                })
                return socialItems
            }
        },
        mounted() {
            // this.stripeCheckout = StripeCheckout.configure({
            //     key: window.stripeKey,
            //     image: '/images/icons/stripe_modal_logo.png',
            //     locale: "auto",
            //     // currency: "EUR",
            //     panelLabel: "Paga",
            //     token: (token) => {
            //         this.form.setData('stripeToken', token.id);
            //         this.form.setData('email', token.email);

            //         $('#spinner-modal').modal();

            //         this.onSubmit()
            //     }
            // });


            let self = this;
            document.addEventListener('DOMContentLoaded', function (event) {
                self.stripe.stripe = Stripe(window.stripeKey),
                self.stripe.elements = self.stripe.stripe.elements();

                var style = {
                    base: {
                        color: '#32325d',
                        fontFamily: '"Montserrat", sans-serif',
                        fontSmoothing: 'antialiased',
                        '::placeholder': {
                            color: '#aab7c4'
                        },
                        ':focus': {},
                    },
                    invalid: {
                        color: '#fa755a',
                        iconColor: '#fa755a'
                    }
                };

                // Create an instance of the card Element.
                self.stripe.card = self.stripe.elements.create('card', {style: style});

                // Add an instance of the card Element into the `card-element` <div>.
                self.stripe.card.mount('#card-element');

                self.stripe.card.addEventListener('change', function (event) {
                    var displayError = document.getElementById('card-errors');
                    if (event.error) {
                        displayError.textContent = event.error.message;
                    } else {
                        displayError.textContent = '';
                    }
                });

            });
        },
        methods: {
            onSubmit() {
                this.form
                    .submit('post', this.source)
                    .then(response => {
                        this.google_inserted = false;
                        this.social_inserted = false;
                        this.form.cart = []
                        $('#spinner-modal').modal('hide');
                        this.form.p_intent = null;
                        this.form.pay_method = null;
                        window.alerts.success('Acquisto confermato!');
                        this.submitRunning = false;
                    })
                    .catch(error => {
                        $('#spinner-modal').modal('hide');
                        this.submitRunning = false;
                        window.alerts.error('Qualcosa è andato storto durante la verifica del pagamento!');
                    })
            },
            onOpenStripeModal() {
                let self = this;
                $('#spinner-modal').modal();
                this.submitRunning = true;
                self.stripe.stripe.createPaymentMethod(
                    'card',
                    self.stripe.card
                ).then(function(result) {
                    if (result.error) {
                        // Show error in payment form
                        self.submitRunning = false;
                        $('#spinner-modal').modal('hide');
                    } else {
                        // Send paymentMethod.id to server
                        self.form.pay_method = result.paymentMethod.id;
                        self.form
                            .submit('post', route('payintent.create'), {}, true)
                            .then( async ({intent}) => {
                                // console.log(intent);
                                self.form.p_intent = intent.id
                                if(intent.status == 'succeeded') {
                                    $('#spinner-modal').modal();
                                    self.onSubmit()
                                } else {
                                    $('#spinner-modal').modal('hide');
                                    const { paymentIntent, error } = await self.stripe.stripe.handleCardAction(
                                        intent.client_secret
                                    );
                                    if (error) {
                                        // Display "error.message" to the user...
                                        self.submitRunning = false;
                                        $('#spinner-modal').modal('hide');
                                        window.alerts.error(error.message);
                                    } else {
                                        $('#spinner-modal').modal();
                                        self.onSubmit();
                                        self.submitRunning = false;
                                    }
                                }

                            })
                            .catch(error => {
                                self.submitRunning = false;
                                $('#spinner-modal').modal('hide');
                                window.alerts.error(error.message);
                            })
                    }
                });

                // this.stripeCheckout.open({
                //     name: 'Pagamento sicuro',
                //     email: this.form.email,
                //     amount: this.form.total * 100
                // });
            },
            addGoogleToCart() {
                let day = this.day_google_selected;
                let amount = this.amount_google_selected;

                let product = {
                    day: day,
                    amount: amount,
                    price: day * amount,
                    type: "Google",
                    courses: this.google_courses
                };
                this.addToCart(product)

                this.$set(this, 'google_courses', [])
            },
            addSocialToCart() {
                let day = this.day_social_selected;
                let amount = this.amount_social_selected;
                let product = {
                    day: day,
                    amount: amount,
                    price: day * amount,
                    type: "Facebook + Instagram",
                    courses: this.social_courses
                };

                this.addToCart(product)
                this.social_courses = []
            },
            addToCart(product) {
                if (product.day && product.amount) {
                    let totalPrice = product.price
                    console.log('form.cart', this.form.cart)

                    let idx = _.findIndex(this.form.cart, i => {
                        return i.type == product.type && i.day == product.day && i.amount == product.amount
                    })
                    if (idx >= 0) {
                        this.$set(this.form.cart[idx], 'courses', this.form.cart[idx].courses.concat(product.courses))
                    } else {
                        this.form.cart.push(product);
                    }

                    let total = 0
                    this.form.cart.forEach(i => {
                        total += (i.price * i.courses.length);
                    })

                    this.total = total
                    this.form.total = total
                    if (product.type === 'Google') {
                        this.google_inserted = true;
                        window.alerts.success('Campagna Google aggiunta al carrello');
                    } else {
                        this.social_inserted = true;
                        window.alerts.success('Campagna Facebook + Instagram aggiunta al carrello');
                    }
                } else {
                    window.alerts.error('Controlla di aver selezionato tutte le opzioni');
                }
            },
            removeCourse(idx, pidx, product) {
                this.total -= product.price;
                this.form.total -= product.price

                product.courses.splice(idx, 1)
                let productType = this.form.cart[pidx].courses
                if (productType.length == 0) {
                    this.form.cart.splice(pidx, 1)
                }

                let checkServiceType = _.findIndex(this.form.cart, i => i.type == product.type)
                if (checkServiceType < 0) {
                    if (product.type === 'Google') {
                        this.google_inserted = false;
                    } else {
                        this.social_inserted = false;
                    }
                }
            },
            googleButtonClass() {
                let classe = ["btn"];
                if (this.google_courses.length == 0) {
                    classe.push('disabled')
                }

                if (this.google_inserted)
                    classe.push("btn-outline-primary");
                else
                    classe.push("btn-primary");
                return classe;
            },
            socialButtonClass() {
                let classe = ["btn"];
                if (this.social_courses.length == 0) {
                    classe.push('disabled')
                }

                if (this.social_inserted)
                    classe.push("btn-outline-primary");
                else
                    classe.push("btn-primary");
                return classe;
            },
        },
    }

</script>




// WEBPACK FOOTER //
// resources/assets/js/components/company/dashboard/partials/MarketingServices.vue